import React, { Component, Fragment } from 'react';
import { withCapoeiraSportState } from 'src/ver2/context';
import './style.css';

export default class NgGameRPGArenaUiExtras extends Component {

    state = {
        nowBlockMoveNumber: -2,
        charExtrasInner: [],
        charExtras: [], // тут будет учитываться откат
        stack: [],
        slots: []
    }

    refs = {
    }

    /*
        stack: [ 1, 2, 5] - просто индексы
    */

    /*
        slots:[
            {
                extraIndex: null, 0, 1 ...
                refreshedInMove: false,
                usedInMove: false
            }
        ]
    */
    keyPressed = (e) => {
        const { key } = e;

        if (this.refs && this.refs.cards && this.refs.cards[key] !== undefined) {
            this.cardClick(this.refs.cards[key]);
        }

        if (this.refs && this.refs.refresh && this.refs.refresh[key] !== undefined) {
            this.refreshClick(this.refs.refresh[key]);
        }
        // if (this.refs && this.refs.cards && )
    }

    getSlots = () => {
        const { slots, charExtras } = this.state;
        let result = [];

        for (let i = 0; i < slots.length; i++) {
            const { extraIndex, usedInMove } = slots[i];
            if (!usedInMove && extraIndex !== null && extraIndex !== undefined) {
                const extra = charExtras[extraIndex];
                if (!!extra) result.push(extra)
            }
        }
        return result;
    }

    setCharExtrasInner = (props) => {

        const { extras, extrasSlots } = props;

        const stack = extras.map(({ index }) => { return index })

        if (!extrasSlots) return;

        const slotsNumber = extrasSlots;
        const slots = []

        for (let i = 0; i < slotsNumber; i++) {
            slots.push({});
        }

        if (slotsNumber === 1) {
            this.refs = {
                refresh: { q: 0 },
                cards: { a: 0 }
            }
        }
        if (slotsNumber === 2) {
            this.refs = {
                refresh: { q: 0, w: 1 },
                cards: { a: 0, s: 1 }
            }
        }

        this.setState({ charExtrasInner: [...extras], charExtras: [...extras], stack, slots, slotsNumber })
    }

    // это первичное использование - нам надо расставить слоты именно в нужном порядке, как они были забиты
    firstSettedBuffs = () => {
        const newState = {};
        const { slotsNumber } = this.state;

        if (!slotsNumber) return;
        let slots = [];
        let stack = [...this.state.stack];

        for (let i = 0; i < slotsNumber; i++) {
            const extraToAddIndex = stack[i]; // это индекс из стака

            slots.push({
                extraIndex: extraToAddIndex,
                refreshedInMove: false,
                usedInMove: false
            })

            //и теперь из стака нужно убрать эту штуку
            stack = stack.reduce((memo, item) => {
                if (item !== extraToAddIndex) return [...memo, item];
                return memo;
            }, [])
        }

        newState.slots = slots;
        newState.stack = stack;

        this.setState(newState);

    }

    // это значит, что нам надо скинуть слот - т.е. вот прямо убрать его 
    refreshSlotPositions = (({ positions, refreshedInMove }) => {

        const newState = {};
        const { charExtras } = this.state;

        let slots = [...this.state.slots];
        let stack = [...this.state.stack];

        // мы должны искать в стаке те карты, которые НЕ БЫЛИ ЗАЮЗАНЫ ТОЛЬКО ЧТО В ХОДЕ
        // если refreshedInMove = false
        let stackToFind = []
        this.state.stack.map(index => {
            if (refreshedInMove || !charExtras[index].usedInLastTurn) {
                stackToFind.push(index)
            }
            return 1;
        })

        positions.forEach((position) => {

            if (position >= slots.length) return;

            // нам надо добавить слот в стопку сброса
            const slotPosition = slots[position];

            // смотрим, было ли что-то
            if (slotPosition.extraIndex !== null && slotPosition.extraIndex !== undefined) {
                stack.push(slotPosition.extraIndex);
            }

            // теперь нужно добавить сюда что-то из стака, но не только что сброшенное
            // и не то, что уже добавлено

            let stackExtraIndex = null;
            while (stackExtraIndex === null) {
                stackExtraIndex = Math.floor((Math.random() - 0.0000005) * stackToFind.length);
                if (slots.find(x => x.extraIndex === stackToFind[stackExtraIndex])) {
                    stackExtraIndex = null;
                }
            }

            const extraToAddIndex = stackToFind[stackExtraIndex]; // это индекс из стака

            slots[position] = {
                extraIndex: extraToAddIndex,
                refreshedInMove,
                usedInMove: false
            }

            //и теперь из стака нужно убрать эту штуку
            stack = stack.reduce((memo, item) => {
                if (item !== extraToAddIndex) return [...memo, item];
                return memo;
            }, [])

        })

        newState.slots = slots;
        newState.stack = stack;

        this.setState(newState);
    })

    // это мы нажали КЛАВИАТУРОЙ
    cardClick = (index) => {
        if (this.disabled) return;
        const { slots, charExtras } = this.state;
        const slot = slots[index];
        if (slot) {
            const { extraIndex, usedInMove } = slot;

            let otkatNow = -1;

            if (extraIndex !== null && extraIndex !== undefined) {
                otkatNow = charExtras[extraIndex].otkatNow;
            }

            let mayClicked = true;
            if (otkatNow <= 0) {
            } else {
                mayClicked = false;
            }

            if (usedInMove || !mayClicked) return;
            this.useSlotPosition({ position: index });
        }
    }

    // нажали на кнопку использования, просто подсвечиваем слот
    useSlotPosition = ({ position }) => {
        const newState = {};

        let slots = [...this.state.slots];
        if (position >= slots.length) return;

        const slotPosition = slots[position];

        // смотрим, есть ли там что-то
        if (slotPosition.extraIndex !== null && slotPosition.extraIndex !== undefined) {
            slots[position].usedInMove = true;
        }

        const { charExtras } = this.state;
        const extra = charExtras[slotPosition.extraIndex];

        const { setPlayerBuff } = this.props;
        setPlayerBuff(extra);

        newState.slots = slots;
        this.setState(newState);
    }

    // это вызывается, когда выбирается чье ui ставить, то есть система говорит ui, что новый ход
    // сначала мы убираем из слотов заюзанные карты в stack
    // далее мы убираем на -1 откаты вообще всем карточкам
    // а потом когда изменится nowBlockMoveNumber мы сделаем рефреш

    // noNewMove - это значит, что по сути хода еще не было

    newMove = ({ nowBlockMoveNumber }, noNewMove) => {
        const newState = {};
        newState.nowBlockMoveNumber = nowBlockMoveNumber;
        newState.slots = [...this.state.slots]
        newState.stack = [...this.state.stack]
        newState.charExtras = this.state.charExtras.map(item => { return { ...item, usedInLastTurn: false } })

        // если в слоте был заюзан элемент, мы его убираем из слотов и добавляем в стак
        // при этом ебашим ему откат
        if (!noNewMove)
            newState.slots = newState.slots.reduce((memo, item) => {
                const { extraIndex } = item;
                if (item.usedInMove) {
                    newState.stack.push(extraIndex);
                    newState.charExtras[extraIndex].usedInLastTurn = true;
                    if (newState.charExtras[extraIndex].otkat) newState.charExtras[extraIndex].otkatNow = newState.charExtras[extraIndex].otkat;
                    return [...memo, { extraIndex: null }];
                }
                return [...memo, { ...item, refreshedInMove: false }];
            }, [])


        if (!noNewMove) {
            console.log('НОВЫЙ ХОД В ЭКСТРА');
            newState.charExtras = newState.charExtras.map(item => {
                const newItem = { ...item };
                if (newItem.otkatNow > 0) {
                    console.log('ОТКАТЫВАЮ EXTRA', newItem)
                    newItem.otkatNow--;
                }
                return newItem;
            })
        }

        this.setState(newState);

        if (!noNewMove) {
            this.refreshAfterMove();
        }
    }

    // эта штыка вызывается после componentDidUpdate, куда пришел новый ход
    refreshAfterMove = () => {
        const { slots } = this.state;
        const positions = [];

        slots.forEach(({ extraIndex }, index) => {
            if (extraIndex === null || extraIndex === undefined) {
                positions.push(index);
            }
        })

        positions && positions.length && this.refreshSlotPositions({ positions, refreshedInMove: false })
    }

    componentDidMount = () => {
        const { extrasInner } = this.props;
        const { extras, extrasSlots } = extrasInner();
        if (extras && extras.length) {
            this.setCharExtrasInner({ extras, extrasSlots });
            this.setState({ nowBlockMoveNumber: -1 });
        }
        document.addEventListener("keypress", this.keyPressed);
    }

    componentWillUnmount = () => {
        document.removeEventListener("keypress", this.keyPressed);
    }

    componentDidUpdate = (_, { nowBlockMoveNumber }) => {
        if (nowBlockMoveNumber !== this.state.nowBlockMoveNumber) {
            if (this.state.nowBlockMoveNumber === -1) {
                this.firstSettedBuffs();
            } else
                this.refreshAfterMove();
        }
    }

    get disabled() { return this.props.disabled }

    render() {
        const { left, top, width, zIndex, arena: { arenaWidth, arenaHeight } } = this.props;

        const uiTechWidth = arenaWidth * 0.3;
        const uiTechHeight = arenaHeight * 0.15 * 2; // пока что

        const uiCardWidth = uiTechWidth * 0.35;
        const uiCardHeight = uiTechHeight * 0.8;

        const { slots, stack, charExtras } = this.state;
        const opacity = this.disabled ? 0.6 : 1;

        return <div style={{ left, top, width: uiTechWidth, height: uiTechHeight, zIndex, opacity }} className='ngg_arena_ui_extras_main'>
            {/* <div className='ngg_arena_ui_extras_main_row'>
                {stack.map(item => <this.Card key={`eci_${item}`} extraIndex={item} width={uiCardWidth} />)}
            </div> */}
            <div className='ngg_arena_ui_extras_main_row'>
                {slots.map((item, index) => <this.Card key={`ecs_${item.extraIndex}_${index}`}
                    extraIndex={item.extraIndex}
                    width={uiCardWidth}
                    inSlots
                    mayRefresh={charExtras[item.extraIndex] ? (!item.refreshedInMove && !item.usedInMove) : true}
                    position={index}
                    usedInMove={item.usedInMove}
                />)}
            </div>
        </div>
    }

    refreshClick = (index) => {
        const { slots, charExtras } = this.state;
        const slot = slots[index];
        if (slot) {
            const { extraIndex, refreshedInMove, usedInMove } = slot;
            const mayRefresh = charExtras[extraIndex] ? (!refreshedInMove && !usedInMove) : true;
            if (!mayRefresh) return;
            this.refreshSlotPositions({ positions: [index], refreshedInMove: true });
        }
    }

    Card = ({ extraIndex, width, inSlots, mayRefresh, position, usedInMove }) => {

        const { charExtras } = this.state;

        let otkatNow = -1;
        let otkat = 0;
        let type = null;
        let specIcon = null;

        if (extraIndex !== null && extraIndex !== undefined) {
            otkatNow = charExtras[extraIndex].otkatNow;
            otkat = charExtras[extraIndex].otkat;
            type = charExtras[extraIndex].type;
            specIcon = charExtras[extraIndex].specIcon;
        }

        // const { otkat, otkatNow, key } = charExtras[extraIndex];

        const height = width * 1.3;
        let refreshClassName = 'ngg_arena_ui_extras_main_card_refresh';
        if (!mayRefresh) refreshClassName += ' ngg_arena_ui_extras_main_card_refresh_refdown';

        let cardClassName = 'ngg_arena_ui_extras_main_card';
        if (usedInMove) cardClassName += ' ngg_arena_ui_extras_main_card_used';
        let mayClicked = true;
        const style = { width, height };
        let backStyle = { height: `100%` };
        if (otkatNow <= 0) {
        } else {
            const percent = (1 - otkatNow / otkat) * 100;
            mayClicked = false;
            backStyle = { height: `${percent}%` }
        }
        if (!mayClicked) cardClassName += ' ngg_arena_ui_extras_main_card_unclicked';


        const onCardClick = () => {
            if (!inSlots || usedInMove || !mayClicked) return;
            if (this.disabled) return;
            // this.useSlotPosition({ position });
            this.cardClick(position);
        }
        const onRefreshClick = (e) => {
            e.stopPropagation();
            if (!inSlots || !mayRefresh) return;
            this.refreshSlotPositions({ positions: [position], refreshedInMove: true });
        }

        //refresh

        return <div onClick={onCardClick} style={style} className={cardClassName}>
            {!!inSlots && <div onClick={onRefreshClick} style={{ left: width * 0.05, width: width * 0.9, height: width * 0.5 }} className={refreshClassName}>
                <img src={`/../images/ver2/snowman/extras/extra_refresh.png`} />
            </div>}
            {type && <img src={`/../images/ver2/snowman/extras/${specIcon || type}.png`} />}
            <div style={backStyle} className='ngg_arena_ui_extras_main_card_back' />
        </div>
    }

}